import { ComingSoon } from './components/ComingSoon';

export function App() {
  return <ComingSoon />;
}
